import { c as _c } from "react/compiler-runtime";
import { useFeatureFlag } from '@newfront-insurance/admin-ui';
import { MSGraphToggle } from '../../ms-graph';

/**
 * Outlook Connect settings component that displays a toggle switch for enabling/disabling Outlook Connect.
 * Uses MSGraphToggle primitive to manage Outlook Connect state.
 */
export function OutlookConnectSettings() {
  const $ = _c(3);
  const isMSGraphAuthEnabled = useFeatureFlag("nova-tools-graph-api", false);
  if (!isMSGraphAuthEnabled) {
    return null;
  }
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex items-center justify-between px-0 py-2"><h3 className="font-medium">Outlook Connect</h3><MSGraphToggle /></div>;
    t1 = <div className="border-border w-full border-t" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex flex-col">{t0}{t1}<div className="flex flex-col gap-2 px-0 py-2"><p className="text-muted-foreground text-sm">Allow Nova to access your Outlook inbox</p></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}